<app-progress-bar class="fixed w-100 loading-layout" *ngIf="loadingService.isLoading()"></app-progress-bar>
<router-outlet></router-outlet>
